"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { loyaltyVideoPlayerInputs } from "@/components/LoyaltyVideoPlayer/LoyaltyVideoPlayer.builder";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { pushBlockInputs } from "../PushBlock/PushBlock.builder";

export const loyaltyPushBlockInputs = [
  ...pushBlockInputs,
  {
    name: "ctaLogged",
    friendlyName: "Call to action label when logged",
    type: "string",
    defaultValue: "Explore",
  },
  {
    name: "hrefLogged",
    type: "url",
    defaultValue: "/",
  },
  {
    name: "ctaRestricted",
    friendlyName: "Call to action label when content is restricted",
    type: "string",
    defaultValue: "Explore",
  },
  {
    name: "hrefRestricted",
    type: "url",
    defaultValue: "/",
  },
  {
    name: "enableVideo",
    friendlyName: "Enable video instead of image",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "videoPreview",
    friendlyName: "Video Preview Configuration",
    type: "object",
    required: true,
    showIf: `options.get("enableVideo") === true`,
    subFields: [...loyaltyVideoPlayerInputs],
  },
] as const satisfies Inputs;

export const LoyaltyPushBlockComponent: RegisteredComponent = {
  name: "LoyaltyPushBlock",
  component: dynamic(async () =>
    withValidation(loyaltyPushBlockInputs, (await import("./LoyaltyPushBlock")).LoyaltyPushBlock, "LoyaltyPushBlock")
  ),
  inputs: loyaltyPushBlockInputs,
  requiresParent: {
    query: {
      "component.name": { $in: ["LoyaltyWrapper"] },
    },
    message: "'LoyaltyPushBlock' component can only be added inside a 'LoyaltyWrapper'",
  },
};
